import React, { useContext, useState } from "react"
import { users_syncProfile } from "@/firebase/clientApp"
import { UserContext } from "@/context/UserContext"
import * as Styles from "@/components/Styles"
import { useFirebase } from "@/firebase/FirebaseProvider"
import { updateProfile } from "@firebase/auth"
import { useMutation } from "@tanstack/react-query"
import { cn } from "@/util/cn"

export default function UserNameFieldContent() {
  const { auth, ...functions } = useFirebase()
  const [fullName, setFullName] = useState("")
  const { setUser } = useContext(UserContext)

  const isFullNameValid = fullName.trim().length >= 1

  const mutation = useMutation({
    mutationFn: async () => {
      const fullNameTrimmed = fullName.trim()

      // // NOTE:KB 5/2/2025 for testing error state
      // await delay(3000)
      // throw new Error("Simulated error")

      const currentUser = auth.currentUser
      if (currentUser) {
        await updateProfile(currentUser, { displayName: fullNameTrimmed })
      }

      await users_syncProfile(functions)

      if (setUser) setUser(currentUser)
    },
  })

  const submit = () => mutation.mutate()
  const isLoadingSubmit = mutation.isPending

  let buttonClass: string

  if (isLoadingSubmit) {
    buttonClass = "bg-indigo-600 opacity-80"
  } else if (!isFullNameValid) {
    buttonClass = "bg-[#838383]"
  } else {
    buttonClass = "bg-indigo-600"
  }

  return (
    <div className={"flex w-full flex-col items-stretch justify-center gap-5"}>
      <h1 className={`${Styles.brandHeadingTextClassName}`}>Full name</h1>
      <label htmlFor={"name"} className={"hidden"}>
        Jane Smith
      </label>
      <input
        data-testid={"name-input"}
        className={
          "w-full rounded-md border border-[#e3e3e3] p-[10px] focus:outline-none"
        }
        aria-label={"Jane Smith"}
        placeholder={"Jane Smith"}
        id={"name"}
        name={"name"}
        type={"text"}
        autoComplete={"name"}
        onChange={(e) => setFullName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            submit()
          }
        }}
        value={fullName}
      />
      <button
        data-testid={"name-button"}
        onClick={submit}
        disabled={isLoadingSubmit || !isFullNameValid}
        className={
          "h-[46px] rounded-md p-[10px] text-sm font-[600] text-white shadow-sm focus:outline-none " +
          buttonClass
        }
      >
        {isLoadingSubmit ? (
          <div className={"relative w-full"}>
            <span>Loading...</span>
            <div role="status" className={"absolute right-0 top-0"}>
              <svg
                aria-hidden="true"
                className="h-5 w-5 animate-spin fill-indigo-600 text-gray-200"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          </div>
        ) : (
          "Next"
        )}
      </button>
      {mutation.isError && (
        <div className={cn("self-center text-[#dc2727]")}>
          {"Sorry, something went wrong. Please try again."}
        </div>
      )}
    </div>
  )
}
